import { useQuery, useQueryClient } from '@tanstack/react-query';
import React from 'react';
import { useHistory, useParams } from 'react-router';
import Form from '@dashboard/components/Formik/Form';
import { useAuth } from '@dashboard/context/AuthContext/AuthContext';
import { useToast } from '@dashboard/context/ToastContext';
import { apiUrl } from '@dashboard/services/env';
import request, { fetcher } from '@dashboard/services/request';
import { templateCategoriesKey, templateCategoryKey } from '@dashboard/lib/queryKeys';

const TemplateAdd = () => {
  const { token } = useAuth();
  const { emitToast } = useToast();
  const { categoryId } = useParams();
  const history = useHistory();
  const queryClient = useQueryClient();

  const {
    data: category,
    isLoading,
    isError,
    refetch,
  } = useQuery({
    queryKey: templateCategoryKey(categoryId),
    queryFn: () => fetcher(`/templates/categories/${categoryId}`, token),
    enabled: !!categoryId,
  });

  if (isLoading) return <div>Loading...</div>;
  if (isError) return <div>Something went wrong</div>;

  return (
    <div className="max-w-xl mx-auto mt-16">
      <h1 className="text-2xl font-bold mb-4">Edit Template Category</h1>
      <Form
        initialValues={{
          title: category.title,
          slug: category.slug,
          order: category.order,
          publicTitle: category.publicTitle,
          publicDescription: category.publicDescription,
        }}
        fields={[
          {
            name: 'title',
            required: true,
            type: 'text',
            label: 'Category title',
          },
          {
            name: 'slug',
            required: true,
            type: 'text',
            label: 'Slug',
          },
          {
            name: 'publicTitle',
            required: false,
            type: 'text',
            label: 'Page title',
          },
          {
            name: 'publicDescription',
            required: false,
            type: 'textarea',
            label: 'Page description',
            minRows: 8,
            autosize: true,
          },
          {
            name: 'order',
            required: false,
            type: 'number',
            label: 'Order',
            placeholder: 'Automatically generated if left empty',
          },
        ]}
        showState={false}
        onSubmit={async values => {
          const response = await request(`${apiUrl}/templates/categories/${categoryId}`, token, {
            method: 'PUT',
            body: JSON.stringify(values),
          });

          return {
            data: response.data,
            error: response,
            onSuccess: () => {
              refetch();
              emitToast({
                title: 'Template saved',
              });
              queryClient.invalidateQueries({ queryKey: templateCategoriesKey });
              history.push('/admin/template-categories');
            },
          };
        }}
      />
    </div>
  );
};

export default TemplateAdd;
